import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import { Icon } from "@/components/common/Icon";
import { INDUSTRIES } from "@/lib/content";

export default function Industries() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        kicker="Industries"
        title="Built for technology-led businesses."
        subtitle="Whatever you build, we help you build the India team behind it. Here's how we support expansion across sectors."
      />

      <section className="section-pad" data-testid="industries-grid">
        <div className="container-px">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.name} i={i}>
                <div className="group h-full rounded-2xl border border-white/8 bg-white/[0.02] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-orange-500/30 hover:bg-white/[0.04]" data-testid={`industry-card-${ind.name.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                  <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-orange-500/20 bg-orange-500/5 text-orange-400 transition-all group-hover:grad-accent group-hover:text-[#1a0f00]">
                    <Icon name={ind.icon} className="h-6 w-6" />
                  </div>
                  <h3 className="font-head text-xl font-bold text-white">{ind.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-400">{ind.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal i={2}>
            <button onClick={() => navigate("/contact")} className="btn-primary mt-12" data-testid="industries-cta">
              Discuss Your Expansion <ArrowRight className="h-4 w-4" />
            </button>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
